const Logo = () =>{
    return (
        <img src="https://victoriasmedical.ai/images/logo_v3.svg" alt="logo" />
    );
}

export default Logo;